import { useMutation, useQueryClient } from '@tanstack/react-query'
import { profileApi } from '@/entities/profile'
import { queryKeys } from '@/shared/api/queryKeys'
import { toast } from '@/shared/model/toast'
import { ApiError } from '@/shared/api/client'
import type { Profile } from '@/shared/api/types'

export function useSaveProfile() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: Profile) => profileApi.save(body),
    onSuccess: (saved) => {
      queryClient.setQueryData(queryKeys.profile, saved)
      // Промпт собирается из анкеты, поэтому его предпросмотр устарел в
      // ту же секунду. Забыть этот сброс — значит показывать человеку
      // старый текст и получить «я сохранил, а ничего не изменилось».
      void queryClient.invalidateQueries({ queryKey: queryKeys.promptPreview })
      toast.success('Анкета сохранена')
    },
    onError: (error) => {
      toast.error(error instanceof ApiError ? error.message : 'Не удалось сохранить')
    },
  })
}
